export default __webpack_public_path__ + "static/media/image_car_not_found.210c0f34.svg";